export var SmsTriggerType;
(function (SmsTriggerType) {
    SmsTriggerType["BIND"] = "bind";
    SmsTriggerType["UNBIND"] = "unbind";
    SmsTriggerType["REGISTER"] = "register";
    SmsTriggerType["FORGET_PASSWORD"] = "forget_password";
    SmsTriggerType["RESET_PHONE_BY_ADMIN"] = "reset_phone_by_admin";
})(SmsTriggerType || (SmsTriggerType = {}));
//# sourceMappingURL=SmsTriggerType.js.map